import { type ServiceMethod } from '@/application/interfaces/service';

export type Params = {
  cartId: string;
  payment_method?: 'pix' | 'credit_card' | 'bank_slip';
};

export type DiscountTypes =
  | 'promo'
  | 'loyaltyProgram'
  | 'employee'
  | 'payment-method'
  | 'stampedPrice'
  | 'specialPrice'
  | 'twoPrices'
  | 'lys';

export type CartSummaryData = {
  serviceTotal: number;
  discount: number;
  freight: number;
  totalDiscountsByType?: Record<DiscountTypes, number>;
  subTotal: number;
  errors: { code: 'LYS_0'; message: string }[];
  items: Item[];
  total: {
    inCash: number;
    inInstallments: {
      maxQuantity: number;
      installmentValue: number;
      totalValue: number;
    };
  };
  pricesByPaymentMethods: {
    bankSlip: number;
    creditCard: number;
    pix: number;
  };
};

export type Item = {
  itemId: string;
  productId: number;
  quantity: number;
  prices: Prices;
  discounts: any[];
};

type Prices = {
  total: Total;
  unit: Unit;
};

type Unit = {
  original: number;
  inCash: number;
  inInstallment: number;
  pricesByPaymentMethods: PricesByPaymentMethods;
};

type Total = {
  inCash: number;
  inInstallment: number;
  pricesByPaymentMethods: PricesByPaymentMethods;
};

type PricesByPaymentMethods = {
  bankSlip: number;
  creditCard: number;
  pix: number;
};

export type Response = {
  data: CartSummaryData;
};

export type QueryParams = {
  payment_method?: 'pix' | 'credit_card' | 'bank_slip';
  simulate: string;
};

const getCartSummary: ServiceMethod<Response, Params> =
  (httpClient) => async (data, options) => {
    const { cartId } = data;

    const { body: response } = await httpClient.get<
      Response,
      Params,
      QueryParams
    >('/api/v3/carts/{cartId}/summary', {
      ...options,
      searchParams: {
        ...(data.payment_method && { payment_method: data.payment_method }),
        simulate: 'true',
      },
      params: {
        cartId,
      },
    });

    return response;
  };

export default getCartSummary;
